import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleUnchecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 7.5,
		cy: 7.5,
		r: 7,
		stroke: "currentColor"
	})
});
export default SvgCircleUnchecked;
